import { BattlePassDaresFilters, } from 'root/src/client/v2/battlePass/features/DropBattlePass/components/BattlePassDaresFilters';
import { BattlePassesBadges } from 'root/src/client/v2/battlePass/features/DropBattlePass/components/BattlePassesBadges';
import { BattlePassFilters, } from 'root/src/client/v2/battlePass/features/DropBattlePass/components/BattlePassFilters';
import { DaresBattlePass, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/components/DaresBattlePass/DaresBattlePass';
import { BattlePassDetailsContextProvider, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/contexts/battlePassDetails.context';
import { DropBattlePassContextProvider, useDropBattlePassContext, } from 'root/src/client/v2/battlePass/features/DropBattlePass/contexts/dropBattlePass.context';
export const DropBattlePass = () => {
    return (<DropBattlePassContextProvider>
			<BattlePassesBadges />
			<DropBattlePassContent />
		</DropBattlePassContextProvider>);
};
export const DropBattlePassContent = () => {
    const { battlePassMnemonicId } = useDropBattlePassContext();
    if (!battlePassMnemonicId) {
        return null;
    }
    return (<BattlePassDetailsContextProvider mnemonicId={battlePassMnemonicId}>
			<BattlePassFilters />
			<div className="mt-2">
				<BattlePassDaresFilters />
				<DaresBattlePass />
			</div>
		</BattlePassDetailsContextProvider>);
};
